import {callBackendApi} from "src/components/service/axios";
import {RequiredUploads} from "./model/required-uploads";
import {DTO} from "../../../common/utils/types";
import {RequiredFile} from "./model/required-file";
import {UploadedFile} from "./model/uploaded-file";

export function getUploadDetailsForReviewCycleFile(
  appId: string,
  appName: string,
  fileCategoryName: string,
  fileType: string
): Promise<{ fileName: string; signedUrl: string }> {
  return callBackendApi(
    "get",
    `/bff/apps/${appId}/gcs/upload-url?fileNameSpace=${appName}&fileType=${fileType}&fileCategoryName=${fileCategoryName}`
  );
}

export function updateUploadedFileNamesForApp(
  appId: string,
  uploadedFileNames: Array<UploadedFile>
): Promise<{ currentStatus: string, applicableActions: string[] }> {
  return callBackendApi(
    "put",
    `/bff/review-management/applications/${appId}/files`,
    uploadedFileNames,
    null,
    false
  );
}

export async function getRequiredUploadsForApplicationFiles(
  appId: string
): Promise<RequiredUploads> {
  const requiredUploadsDTO: Array<DTO<RequiredFile>> = await callBackendApi(
    "get",
    `/bff/review-management/applications/${appId}/required-uploads`
  );
  return new RequiredUploads(requiredUploadsDTO);
}

export type DeleteFilesInGCSType = { deleteFileInfos: Array<DeleteFileInGCSType> };

export type DeleteFileInGCSType = {
  fileNameSpace: string;
  fileName: string;
  fileCategoryName: string;
};

export async function deletedUploadedFilesInGcs(deleteFilesInGCS: DeleteFilesInGCSType) {
  await callBackendApi("put", "/bff/gcs/delete-files", deleteFilesInGCS, null, false);
}
